
import K9SeatEntityBase from "./k9_seat_entity_base";
import { K9 } from "./k9_data";
import K9TableModuleBase from "./k9_talbe_module_base";
import K9SeatView from "./component/k9_seat_view";
import K9Help from "./component/k9_help";

const {ccclass, property} = cc._decorator;

//庄家
@ccclass
export default class K9SeatBank extends K9SeatEntityBase {

    //初始化
    onShow(data:K9.SeatBankData){
        if (!data) {
            return;
        }
        super.onShow(data);
        this.seatView.node.active = true;
        this.updateLoopCnt(data.banker_loop_cnt,data.player_id == 0);
        this.updateBet(false);
        this.updateMask(data);
    }

    initBank(node:cc.Node,parent:K9TableModuleBase){
        this.seatView = node.getComponent(K9SeatView);
        this.seatView.loopCnt = cc.find('haveplayer/loopcnt',node).getComponent(cc.Label);
        this.seatView.syslab = cc.find('haveplayer/sys',node)
        this.parent = parent;
        this.seatPos = -1;//庄家
        this.seatView.registerClickFunc(this.showChat.bind(this))
    }

    protected updateLoopCnt(count:number,isSys:boolean){
        this.seatView.loopCnt.node.active = !isSys;
        this.seatView.syslab.active = isSys;
        this.seatView.loopCnt.string = (isSys ? 'x':count+'')
    }

    updateBankEntity(data:K9.SeatBankData){
        if (!data) {
            return;
        }
        this.updateMask(data);
        this.updateStateUI(data);
        this.updatePlayerInfo(data);
        
    }

    protected updateMask(data:K9.SeatBankData){
        if (!data) {
            return;
        }
        if (data.seat_pos == 0) {
            this.isShowMask(data.seat_pos,false);
            
        }else{
            this.isShowMask(data.seat_pos,data.state == K9.PlayerState.NoInGame);
        }
    }

    onLeave(){
        super.onLeave();

    }

    bankMove(func1:Function,func2:Function,fun3:Function){
        
        let seatNode = this.seatView.node;
        let moveLeft = cc.moveTo(0.2,cc.v2(-80,0));
        let fadeOut = cc.fadeOut(0.2);
        let func = cc.callFunc(()=>{
            if (func1) {
                func1();
            }
            this.setPosition(cc.v2(80,0));
        })
        let sqwanOut=cc.spawn(moveLeft,fadeOut);
        let moveCenter = cc.moveTo(0.2,cc.v2(0,0));
        let fadeIn = cc.fadeIn(0.2);
        let sqwanIn=cc.spawn(moveCenter,fadeIn);
        let delay = cc.delayTime(0.1);

        let beginFunc = cc.callFunc(()=>{
            if (func2) {
                func2();
            }
        })
        let overFunc = cc.callFunc(()=>{
            if (fun3) {
                fun3()
            }
        })
        seatNode.stopAllActions();        
        let seq = cc.sequence(sqwanOut,func,delay,beginFunc,sqwanIn,overFunc);
        seatNode.runAction(seq);
    }

    updateOperator(){

    }

    settlementStep2(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
    }

    //步骤 归池
    settlementStep3(data:K9.SeatData,func:Function){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        //输家
        if (data.balance < 0) {
            this.seatView.stopUserAction(K9.ActionTag.guici1)
            let action = K9Help.delay(this.seatView.timer,()=>{
                this.obtainBetEx(this.seatView.betEndNode,this.parent.getPotNode(),-data.balance,()=>{
                    if (func) {
                        func();
                    }
                })
            },0.3)
            action.setTag(K9.ActionTag.guici1);
        }
    }

    //步骤3 飞筹码
    settlementStep4(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (data.balance > 0) {
            this.obtainBetEx(this.parent.getPotNode(),this.seatView.betEndNode,data.balance+data.bet_coin,()=>{
                
            })
            this.updateBet(false);
        }

        this.seatView.isShowName(true);
        this.seatView.showOperator(false);


    }

    //获取筹码并飘风
    settlementStep5(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        this.seatView.grayPattern(data);
        this.seatView.setScore(data.real_balance != 0,data.real_balance,()=>{
            this.seatView.isShowName(false);
        });
    }
}
